export const getCustomerInputs = (initialValues) => [
  {
    groupName: "Customer Information",
    type: "TEXT",
    label: "Customer Name",
    id: "customer_name",
    name: "customer_name",
    value: initialValues?.customer_name || "",
    placeholder: "Enter the Customer Name",
    validations: [
      {
        type: "REQUIRED",
        message: "Customer Name is required !",
      },
    ],
  },
  {
    groupName: "Customer Information",
    type: "TEXT",
    label: "Email",
    id: "email",
    name: "email",
    value: initialValues?.email || "",
    placeholder: "Enter the Email Address",
    validations: [
      {
        type: "REQUIRED",
        message: "Email is required !",
      },
      {
        type: "EMAIL",
        message: "Please enter a valid email address !",
      },
    ],
  },
  {
    groupName: "Customer Information",
    type: "TEXT",
    label: "Mobile",
    id: "mobile",
    name: "mobile",
    value: initialValues?.mobile || "",
    placeholder: "Enter the Mobile Number",
    validations: [
      {
        type: "REQUIRED",
        message: "Mobile is required !",
      },
    ],
  },
  {
    groupName: "Customer Information",
    type: "PASSWORD",
    label: "Password",
    id: "password",
    name: "password",
    value: initialValues?.password || "",
    placeholder: "Enter the Password",
    validations: [
      {
        type: "REQUIRED",
        message: "Password is required !",
      },
      {
        type: "MIN_LENGTH",
        value: 6,
        message: "Password must be at least 6 characters !",
      },
    ],
  },
  {
    groupName: "Customer Information",
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: [
      { name: "Active", value: "1" },
      { name: "Inactive", value: "0" },
    ],
    value: initialValues?.status || "1",
    placeholder: "Select status",
  },
];
